import { useEffect, useState } from "react";

const Pray = () => {

  /* INSTANT LOAD FROM CACHE */

  const [today, setToday] = useState(() => {

    const saved = localStorage.getItem("lastPrayers");

    if (saved) {
      return JSON.parse(saved);
    }

    return null;

  });


  /* SECTION STATE */

  const getAutoSection = () => {

    const hour = new Date().getHours();

    if (hour >= 4 && hour <= 11) return "morning";
    if (hour >= 12 && hour <= 15) return "midday";
    if (hour >= 16 && hour <= 20) return "evening";

    return "night";
  };


  const [openSections, setOpenSections] = useState(() => {

    const saved = localStorage.getItem("praySections");

    if (saved) {
      return JSON.parse(saved);
    }

    const auto = getAutoSection();

    return {
      morning: auto === "morning",
      midday: auto === "midday",
      evening: auto === "evening",
      night: auto === "night",
      rosary: false
    };

  });


  /* TOGGLE (ONLY ONE OPEN) */

  const toggleSection = (section) => {

    const updated = {
      morning: false,
      midday: false,
      evening: false,
      night: false,
      rosary: false
    };

    updated[section] = !openSections[section];

    setOpenSections(updated);

    localStorage.setItem(
      "praySections",
      JSON.stringify(updated)
    );

  };


  /* LOAD PRAYERS */

  useEffect(() => {

    fetch("https://pax-ordinis-app-db9z.vercel.app/api/today?lang=en")

      .then(res => res.json())

      .then(data => {

        setToday(data);

        localStorage.setItem(
          "lastPrayers",
          JSON.stringify(data)
        );

      })

      .catch(() => {

        const saved = localStorage.getItem("lastPrayers");

        if (saved) {
          setToday(JSON.parse(saved));
        }

      });

  }, []);



  /* AUTO-SCROLL TO OPEN SECTION */

  useEffect(() => {

    const auto = getAutoSection();

    setTimeout(() => {

      const element = document.getElementById(auto);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

    }, 300);

  }, []);



  if (!today) {

    return (
      <div className="pray-space">
        <p>Loading prayers...</p>
      </div>
    );

  }



  const renderBlock = (blocks) => {

    return blocks.map((item, index) => (

      <div
        key={index}
        className="pray-block"
      >

        <h3 className="pray-block-title">
          {item.title}
        </h3>

        <p className="pray-block-content">
          {item.content}
        </p>

      </div>

    ));

  };



  return (

    <div
      data-testid="space-pray"
      className="pray-space"
    >


      <h1 className="pray-title">
        Pray
      </h1>


      <p className="pray-threshold">
        A threshold, not a task.
      </p>



      {/* MORNING */}

      <h2
        id="morning"
        className="pray-section"
        onClick={() =>
          toggleSection("morning")
        }
      >

        Morning {openSections.morning ? "−" : "+"}

      </h2>


      <div
        className={
          "pray-content " +
          (openSections.morning
            ? "open"
            : "closed")
        }
      >

        {openSections.morning && renderBlock(today.morning)}

      </div>



      {/* MIDDAY */}

      <h2
        id="midday"
        className="pray-section"
        onClick={() =>
          toggleSection("midday")
        }
      >

        Midday {openSections.midday ? "−" : "+"}

      </h2>


      <div
        className={
          "pray-content " +
          (openSections.midday
            ? "open"
            : "closed")
        }
      >

        {openSections.midday && renderBlock(today.midday)}

      </div>



      {/* EVENING */}

      <h2
        id="evening"
        className="pray-section"
        onClick={() =>
          toggleSection("evening")
        }
      >

        Evening {openSections.evening ? "−" : "+"}

      </h2>


      <div
        className={
          "pray-content " +
          (openSections.evening
            ? "open"
            : "closed")
        }
      >

        {openSections.evening && renderBlock(today.evening)}

      </div>



      {/* NIGHT */}

      <h2
        id="night"
        className="pray-section"
        onClick={() =>
          toggleSection("night")
        }
      >

        Night {openSections.night ? "−" : "+"}

      </h2>


      <div
        className={
          "pray-content " +
          (openSections.night
            ? "open"
            : "closed")
        }
      >

        {openSections.night && renderBlock(today.night)}

      </div>



      {/* ROSARY */}

      <h2
        id="rosary"
        className="pray-section"
        onClick={() =>
          toggleSection("rosary")
        }
      >

        Rosary — {today.rosary.mystery_set} Mysteries {openSections.rosary ? "−" : "+"}

      </h2>


      <div
        className={
          "pray-content " +
          (openSections.rosary
            ? "open"
            : "closed")
        }
      >

        {openSections.rosary &&
          today.rosary.mysteries.map(
            (mystery, index) => (

              <div
                key={index}
                className="pray-block"
              >

                <div className="pray-block-title">
                  {mystery.title}
                </div>

                <div className="pray-block-content">
                  {mystery.content}
                </div>

              </div>

            )
          )}

      </div>



    </div>

  );

};

export default Pray;
